/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { ParamValueModel } from '../../../../../models/ParamValueModel';
import { User } from '../../../../../models/User';

declare let jQuery;

@Component({
  selector: 'app-publisher-overview',
  templateUrl: './app-publisher-overview.html',
  styleUrls: ['./app-publisher-overview.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppPublisherOverview implements OnInit, OnChanges {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() os;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() toAppDiscovery = new EventEmitter<ParamValueModel>();
  @Output() followClick = new EventEmitter<boolean>();
  publisherParam: string;
  tooltipTempate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
  isPopup = false;
  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];

  get isAppDiscoveryEnabled(): boolean {
    return this.user.appDiscoveryEnabled();
  }

  constructor(private user: User, private _router: Router) {}

  ngOnInit() {
    setTimeout(() => {
      this.isPopup = top !== self;
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      setTimeout(() => {
        this.publisherParam = encodeURIComponent(
          'publisherName=' + this.data['appOverview']['publisherName']
        );
      }, 100);
    }
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }

  getRatingFilterParam(param: string, value: string) {
    const valueString =
      value === 'low'
        ? 'L'
        : value === 'medium'
        ? 'M'
        : value === 'high'
        ? 'H'
        : '';
    if (valueString && valueString.length > 0) {
      return encodeURIComponent(param + '=' + valueString);
    }
    return '';
  }

  getRating(paramValue: string) {
    if (paramValue === 'low') {
      paramValue = 'L';
    }
    if (paramValue === 'medium') {
      paramValue = 'M';
    }
    if (paramValue === 'high') {
      paramValue = 'H';
    }
    return paramValue;
  }

  goToAppDiscovery(param: string, paramValue: string) {
    if (paramValue !== 'N/A') {
      if (paramValue === 'low') {
        paramValue = 'L';
      }
      if (paramValue === 'medium') {
        paramValue = 'M';
      }
      if (paramValue === 'high') {
        paramValue = 'H';
      }
      const queryParams = {};
      queryParams[param] = paramValue;
      jQuery('*[title]').tooltip('hide');
      setTimeout(() => {
        void this._router.navigate(
          ['/discovery/apps/list', this.os, 'all', this.region],
          { queryParams: queryParams }
        );
      }, 100);
    }
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
